import { tokenGetCode } from "@/api/user";
import { getMeetingConfig } from "@/api/play";
import store from "@/store";
import { getPlatformConfig } from "@/api/user";

const devUrlsPC = {
  EXPERT: "http://testexpertlist.morehealth.net.cn/auth", // 主题
  NERVE: "http://testnerve.morehealth.net.cn/auth", // 脑健康
  BASEHOME: "http://testpediatrics.morehealth.net.cn/auth", // 医邻壹里儿科首页
  BXB: "http://testclt.morehealth.net.cn",
};

const prodUrlsPC = {
  EXPERT: "https://expertlist.morehealth.net.cn/auth", // 主题
  NERVE: "https://nnmtp.morehealth.net.cn/auth", // 脑健康
  BASEHOME: "http://pediatrics.morehealth.net.cn/auth", // 医邻壹里儿科首页
  BXB: "https://clt.morehealth.net.cn",
};

const devUrls = {
  THEME_PM: "http://testpmphch5.morehealth.net.cn", // 精准医学
  NERVE: "http://testnerveh5.morehealth.net.cn", // 脑健康
  THEME_MS: "http://testnerveh5.morehealth.net.cn", // ms
  THEME_STROKE: "http://teststrokeh5.morehealth.net.cn", // 脑卒中
  EXPERT_APPLET: "https://minitest.ntppc.org.cn", // 专家中心
  COMMON_THEME: "http://testtopicsh5.morehealth.net.cn", //公共主题
  BASEHOME: "http://testpediatricsh5.morehealth.net.cn", //新儿科首页
  ORIGINERKE: "http://test.h5.ntppc.org.cn", // 国培儿科-纯链接
  ONEL: "http://testonel.morehealth.net.cn", //医邻壹里-纯链接
  SHOP: "http://kehu507.damaicheng.cn/html/m1/", //商城-纯链接
  THEME_CNU: "http://testcnuh5.morehealth.net.cn", // 儿童营养
  THEME_PR: "http://testprh5.morehealth.net.cn", // 儿童康复

  BASE: "http://test.h5.ntppc.org.cn/pages/auth/auth", // 国培儿科
  THEME_LEUKEMIA: "http://testclth5.morehealth.net.cn/pages/auth/auth", //白血病
  THEME_FJF: "http://test.theme.fjf.h5.morehealth.net.cn/pages/auth/auth", // 儿童生长和发育
  THEME_CHEST: "http://testcpich5.morehealth.net.cn/pages/auth/auth", // 儿童胸痛
};

const prodUrls = {
  THEME_PM: "https://pmphch5.morehealth.net.cn", // 精准医学
  NERVE: "https://nnmtph5.morehealth.net.cn", // 脑健康
  THEME_MS: "https://nnmtph5.morehealth.net.cn", // ms
  THEME_STROKE: "https://strokeh5.morehealth.net.cn", // 脑卒中
  EXPERT_APPLET: "https://mini.morehealth.net.cn", // 专家中心
  COMMON_THEME: "https://topicsh5.morehealth.net.cn", // 公共主题
  BASEHOME: "https://pediatricsh5.morehealth.net.cn", // 新儿科首页
  ORIGINERKE: "http://www.h5.ntppc.org.cn", // 国培儿科-纯链接
  ONEL: "https://onel.morehealth.net.cn", // 医邻壹里-纯链接
  SHOP: "http://kehu550.damaicheng.com/html/m2/", // 商城-纯链接
  THEME_CNU: "https://cnuh5.morehealth.net.cn", // 儿童营养
  THEME_PR: "https://prh5.morehealth.net.cn", // 儿童康复

  BASE: "http://www.h5.ntppc.org.cn/pages/auth/auth", // 国培儿科
  THEME_LEUKEMIA: "https://clth5.morehealth.net.cn/pages/auth/auth", // 白血病
  THEME_FJF: "https://theme.fjf.h5.morehealth.net.cn/pages/auth/auth", // 儿童生长和发育
  THEME_CHEST: "https://cpich5.morehealth.net.cn/pages/auth/auth", // 儿童胸痛
};

export const getJumpUrl = (
  origin = sessionStorage.getItem("_big_origin"),
  query = {}
) => {
  const searchParams = new URLSearchParams(query);
  const env = process.env.NODE_ENV;
  // 兼容新公共主题
  if (origin?.startsWith("THEME_ID_")) {
    // 截取主题id
    const id = origin.slice(9);
    searchParams.delete("_type");
    searchParams.append("theme_id", id);
    const queryString = searchParams.toString();
    if (env === "production") {
      return `${prodUrls["COMMON_THEME"]}?${queryString}`;
    } else {
      return `${devUrls["COMMON_THEME"]}?${queryString}`;
    }
  } else {
    searchParams.delete("_to_path");
    const queryString = searchParams.toString();
    let url = query._to_path
      ? `${prodUrls[origin]}/${query._to_path}`
      : `${prodUrls[origin]}`;
    if (env === "production") {
      return queryString ? `${url}?${queryString}` : url;
    } else {
      let url = query._to_path
        ? `${devUrls[origin]}/${query._to_path}`
        : `${devUrls[origin]}`;
      return queryString ? `${url}?${queryString}` : url;
    }
  }
};

export const getJumpUrlPC = async (
  origin = sessionStorage.getItem("_big_origin"),
  query = {}
) => {
  const { results } = await tokenGetCode();
  // 删掉参数里面的token使用code
  delete query.token;
  query.code = results;
  const searchParams = new URLSearchParams(query);
  const env = process.env.NODE_ENV;
  // 兼容新公共主题
  if (origin?.startsWith("theme_id_")) {
    // 截取主题id
    const id = origin.slice(9);
    searchParams.append("theme_id", id);
    const queryString = searchParams.toString();
    if (env === "production") {
      return `${prodUrlsPC["common_theme"]}?${queryString}`;
    } else {
      return `${devUrlsPC["common_theme"]}?${queryString}`;
    }
  } else if (origin?.startsWith("conference_id_")) {
    // 截取主题id
    const id = origin.slice(14);
    if (env === "production") {
      location.assign(`https://meeting${id}.morehealth.net.cn/`);
    } else {
      location.assign(`https://testmeeting${id}.morehealth.net.cn/`);
    }
  } else {
    const queryString = searchParams.toString();
    if (env === "production") {
      return queryString
        ? `${prodUrlsPC[origin]}?${queryString}`
        : prodUrlsPC[origin];
    } else {
      return queryString
        ? `${devUrlsPC[origin]}?${queryString}`
        : devUrlsPC[origin];
    }
  }
};

export const _returnUrl = async (_return_url) => {
  const { results } = await tokenGetCode();
  let urlObj = new URL(_return_url);
  urlObj.searchParams.set("_code", results);
  const newUrl = urlObj.toString();
  window.location.href = newUrl;
};

export const _backUrl = async (_back_url) => {
  const { results } = await tokenGetCode();
  let urlObj = new URL(_back_url);
  urlObj.searchParams.set("_code", results);
  const newUrl = urlObj.toString();
  window.location.assign(newUrl);
};

export const get_big_origin = () => {
  let registerSource = sessionStorage.getItem("_big_origin") ?? "";
  return registerSource || "";
};

export const toLowerCase = (str) => {
  return str.toLowerCase();
};

export const getRegisterSource = (
  origin = sessionStorage.getItem("_big_origin")
) => {
  let registerSource = "";
  // 新公共主题
  if (origin?.startsWith("theme_id_")) {
    // 转大写
    registerSource = origin.toUpperCase();
  } else if (origin?.startsWith("platform_id_")) {
    // 转大写
    registerSource = origin.toUpperCase();
  } else if (origin?.startsWith("conference_")) {
    // 转大写
    registerSource = origin.toUpperCase();
  } else {
    switch (origin) {
      case "expert":
        registerSource = "EXPERT_APPLET";
        break;
      case "zyek":
        registerSource = "THEME_CHINESEMEDICINE";
        break;
      case "yygl":
        registerSource = "THEME_HOSPITALMANAGE";
        break;
      case "cqb":
        registerSource = "THEME_KAWASAKI_DISEASE";
        break;
      case "bxb":
        registerSource = "THEME_LEUKEMIA";
        break;
      case "ddbs":
        registerSource = "THEME_BILIARY_ATRESIA";
        break;
      case "robot":
        registerSource = "THEME_ROBOT";
        break;
      case "sma":
        registerSource = "THEME_SMA";
        break;
      case "pr":
        registerSource = "THEME_PR";
        break;
      case "fjf":
        registerSource = "THEME_FJF";
        break;
      case "cnu":
        registerSource = "THEME_CNU";
        break;
      case "chest":
        registerSource = "THEME_CHEST";
        break;
      case "erke":
        registerSource = "BASE";
        break;
      case "nerve":
        registerSource = "NERVE";
        break;
      case "ms":
        registerSource = "THEME_MS";
        break;
      case "pm":
        registerSource = "THEME_PM";
        break;
      case "stroke":
        registerSource = "THEME_STROKE";
        break;
      case "erkehome":
        registerSource = "BASEHOME";
        break;
      case "yanke":
        registerSource = "EYE";
        break;
      default:
        registerSource = "";
    }
  }

  return registerSource;
};

export const getRegisterSource2 = (origin) => {
  let registerSource = "";
  // 新公共主题
  if (origin?.startsWith("THEME_ID_")) {
    // 转小写
    registerSource = origin.toLowerCase();
  } else if (origin?.startsWith("PLATFORM_ID_")) {
    // 转小写
    registerSource = origin.toLowerCase();
  } else if (origin?.startsWith("CONFERENCE_")) {
    // 转小写
    registerSource = origin.toLowerCase();
  } else {
    switch (origin) {
      case "EXPERT_APPLET":
        registerSource = "expert";
        break;
      case "THEME_CHINESEMEDICINE":
        registerSource = "zyek";
        break;
      case "THEME_HOSPITALMANAGE":
        registerSource = "yygl";
        break;
      case "THEME_KAWASAKI_DISEASE":
        registerSource = "cqb";
        break;
      case "THEME_LEUKEMIA":
        registerSource = "bxb";
        break;
      case "THEME_BILIARY_ATRESIA":
        registerSource = "ddbs";
        break;
      case "THEME_ROBOT":
        registerSource = "robot";
        break;
      case "THEME_SMA":
        registerSource = "sma";
        break;
      case "THEME_PR":
        registerSource = "pr";
        break;
      case "THEME_FJF":
        registerSource = "fjf";
        break;
      case "THEME_CNU":
        registerSource = "cnu";
        break;
      case "THEME_CHEST":
        registerSource = "chest";
        break;
      case "BASE":
        registerSource = "erke";
        break;
      case "NERVE":
        registerSource = "nerve";
        break;
      case "THEME_MS":
        registerSource = "ms";
        break;
      case "THEME_PM":
        registerSource = "pm";
        break;
      case "THEME_STROKE":
        registerSource = "stroke";
        break;
      case "BASEHOME":
        registerSource = "erkehome";
        break;
      case "EYE":
        registerSource = "yanke";
        break;
      default:
        registerSource = "";
    }
  }

  return registerSource;
};

// 转公众号来源
// YM_EXPERT、YM_NERVE共用测试公众号 源墨医学科技 wxe7ca9d0d239a13d2
// YM_PM、YM_EYE共用测试公众号 源墨科技 wx9c324879b552a944
export const getCustomerServiceQrCode = async (
  origin = sessionStorage.getItem("_big_origin")
) => {
  let registerSource = "";
  if (origin) {
    console.log(origin);
    switch (origin) {
      case "THEME_PM":
        registerSource = "YM_PM";
        break;
      case "NERVE":
        registerSource = "YM_NERVE";
        break;
      case "THEME_MS":
        registerSource = "YM_NERVE";
        break;
      case "EYE":
        registerSource = "YM_EYE";
        break;
      default:
        registerSource = "YM_EXPERT";
    }
    if (origin && origin.startsWith("PLATFORM_ID_")) {
      const id = origin.slice(12);
      const { results } = await getPlatformConfig({ platformId: id });
      registerSource = results.owner;
    }
  } else {
    registerSource = "YM_EXPERT";
  }
  return registerSource;
};

export const isWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") != -1;
};

// 是都是电脑端微信浏览器
export const isPcWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("windowswechat") || ua.includes("macwechat");
};

export const setTitle = (title) => {
  document.title = title;
  var i = document.createElement("iframe");
  i.style.display = "none";
  i.onload = function () {
    setTimeout(function () {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
};

export function deepCopy(currentObj) {
  let newObj = Array.isArray(currentObj) ? [] : {}; //Step#1
  for (let key in currentObj) {
    //Step#2
    let property = currentObj[key];
    if (typeof property === "object") {
      newObj[key] = deepCopy(property); //Step#3
    } else {
      newObj[key] = property; //Step#3
    }
  }
  return newObj;
}

export const generateSharelink = (link, origin) => {
  let _link = link;
  // 没_big_origin参数 拼上参数
  if (!link.includes("_big_origin")) {
    if (link.includes("?")) {
      _link = `${_link}&_big_origin=${origin}`;
    } else {
      _link = `${_link}?_big_origin=${origin}`;
    }
  }

  return _link;
};

// 防抖
export function debounce(fn, delay) {
  // fn 是函数调用时的第一个函数参数
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export const formatTime2 = (date) => {
  return date.replace(/-/g, "/");
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(
    navigator.userAgent
  );
};

export const isMobileClient = () => {
  return window.document.body.clientWidth - 1 < 1200;
};

// 获取当前网站的子域名
export function extractMeetingId(url = location.href) {
  // 使用正则表达式匹配meeting后面的数字
  var match = url.match(/meeting(\d+)/);
  if (match && match[1]) {
    // 如果匹配成功，返回提取的数字部分
    return match[1];
  } else {
    // 如果匹配失败，返回null或者其他适当的值
    return null;
  }
}

// 获取主机名
export function getHostname(url = location.href) {
  // 创建 URL 对象
  var parsedUrl = new URL(url);
  // 返回主机名部分
  return parsedUrl.hostname;
}

// 获取主题大写来源
export const getBigOrigin = () => {
  const id = store.getters["config/getPlatformId"];
  return id ? `CONFERENCE_ID_${id}` : "";
};

// 下载
export function download(name, url) {
  const fileExtension =
    name.split(".").pop().toLowerCase() || url.split(".").pop().toLowerCase();
  // 根据文件后缀名判断文件类型
  if (fileExtension === "pdf") {
    // 如果是 PDF 文件，打开新窗口预览
    window.open(url, "_blank");
  } else if (fileExtension === "doc" || fileExtension === "docx") {
    // 如果是 DOC 或 DOCX 文件，进行下载
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", name);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // 其他类型的文件，您可以自定义处理方式
    alert("不支持的文件类型，请下载。");
  }
}

// pc跳转
export const pcToLink = async (url) => {
  try {
    const domain = url.split(".")[1];
    const token = localStorage.getItem("token");
    if (!token && domain === "morehealth") {
      store.commit("user/setPcLoginPop", true);
      return;
    }
    const link = new URL(url);
    let outlink = "";
    const source = getBigOrigin();
    const { results: code } = await tokenGetCode();
    const backurl = location.href;
    if (link.search) {
      outlink =
        url + "&source=" + source + "&code=" + code + "&_back_url=" + backurl;
    } else {
      outlink =
        url + "?source=" + source + "&code=" + code + "&_back_url=" + backurl;
    }
    window.open(outlink, "_blank");
  } catch (error) {
    window.open(url, "_blank");
  }
};

export const msToTime = (duration) => {
  let seconds = Math.floor(duration / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  // 计算剩余的分钟和秒数
  minutes = minutes % 60;
  seconds = seconds % 60;

  // 使用padStart来确保数字前面有足够的0
  let hoursFormatted = String(hours).padStart(2, "0");
  let minutesFormatted = String(minutes).padStart(2, "0");
  let secondsFormatted = String(seconds).padStart(2, "0");
  if (hours > 0) {
    return `${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`;
  } else {
    return `${minutesFormatted}:${secondsFormatted}`;
  }
};
// 打开文件
export function openFile(url) {
  // 需要收费

  const sufix = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
  if (sufix === "pdf") {
    // window.open(url);
    window.open(url);
  } else {
    // office免费
    window.open(
      "https://view.officeapps.live.com/op/view.aspx?src=" +
        encodeURIComponent(url)
    );
  }
}

// footer底部跳转
export const getfootUrl = (name) => {
  const env = process.env.NODE_ENV;
  if (env === "production") {
    return prodUrlsPC[name] + "?type=index";
  } else {
    return devUrlsPC[name] + "?type=index";
  }
};

// 根据来源获取图片
// 脑健康 医邻儿科 精准医学 卒中学院
export const getHeaderImg = async (
  origin = sessionStorage.getItem("_big_origin")
) => {
  if (origin && origin.startsWith("PLATFORM_ID_")) {
    // 获取平台id
    const id = origin.slice(12);
    const { results } = await getPlatformConfig({ platformId: id });

    return [results.platformName, results.platformLogo];
  }

  if (origin && origin.startsWith("CONFERENCE_ID_")) {
    // 获取平台id
    const id = origin.slice(14);
    const { results } = await getMeetingConfig(id);
    return [results.platformName, results.topLogo];
  }

  let _imgPath = "yl";
  if (
    ["NERVE", "THEME_MS", "THEME_PM", "THEME_STROKE", "BASEHOME"].includes(
      origin
    )
  ) {
    _imgPath = origin;
  }

  return import(`@/assets/PC/logo/${_imgPath}.png`);
};

export const getH5_accounth = (id, userId) => {
  const origin = sessionStorage.getItem("_big_origin") ?? "";
  const utype = "peshare"; //记录生成海报的用户 // pePoster:海报，peshare: 分享
  const env = process.env.NODE_ENV;
  let urlList = {
    production: `https://accounth5.morehealth.net.cn/patienteducationdetail?patientEduId=${id}&_big_origin=${origin}&userid=${userId}&utype=${utype}`,
    development: `http://testymcenter.morehealth.net.cn/patienteducationdetail?patientEduId=${id}&_big_origin=${origin}&userid=${userId}&utype=${utype}`, // 测试环境是staging
  };
  if (env == "production") {
    return urlList[env];
  } else {
    return urlList["development"];
  }
};
